export const ARROW_POINTER_LIMIT = 5
